import {
  defineCustomElement as VueDefineCustomElement,
  createApp,
  getCurrentInstance,
  h,
} from 'vue'

// import { registerSW } from 'virtual:pwa-register'
import quasarStyles from 'quasar/src/css/index.sass'
import toastStyles from 'vue-toastification/dist/index.css'
import globalFilter from '@/helpers/filters'
// TODO: Import lib css
import appStyles from '@/styles/app.scss'
import { INITIAL_LINKS } from '@/configs/app.config'

import {
  createEventProxies,
  cssCompiler,
  linksLoader,
  modifyRoot,
  styleLoader,
} from '@/utils/build'

export const defineCustomElement = (component) => {
  const modules = import.meta.glob<any>('/src/modules/*.ts', { eager: true })

  // *: Attach link loaders
  linksLoader(INITIAL_LINKS)

  // *: register Service Worker
  // registerSW();
  return VueDefineCustomElement({
    props: component.props,
    setup(props) {
      // TODO: Execute exposed please use this
      // component.setup(props, ctx)
      // *: Create Event Proxies
      const _props = createEventProxies(component)

      // ?: Make sure instance founded
      const inst: AnyObject = getCurrentInstance() || {}

      const cssText = styleLoader(
        modifyRoot(quasarStyles),
        toastStyles,
        appStyles.toString(),
      ).join('')

      // !: Enhancer CSS with custom compiler
      cssCompiler(cssText)

      // ?: modifier instance with plugins
      const app = createApp(component)

      //* Install all modules under `modules/`
      Object.values(modules).forEach((module: any) => module.install?.(app))

      // *: dependencies injection
      app.config.globalProperties.$filters = globalFilter
      Object.assign(inst.appContext, app._context)
      Object.assign(inst.provides, app._context.provides)

      return () => h(component, { ...props, ..._props })
    },
  })
}
